import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";

const InfoCard = ({
    title,
    value,
    subtitle,
    valueColor = "gray.800",
    subtitleColor = "gray.400",
    bg = "white",
    center = false,
    border = false,
    spaceAround = false
}) => {
    return (
        <Box
            className="info-card"
            bg={bg}
            border={border ? "1px solid #0000001a" : "none"}
            borderRadius="15px"
            p={5}
            flex="1"
            minW="200px"
            textAlign={center ? "center" : "left"}
        >
            {spaceAround ?
                <Flex justifyContent={"space-between"}>
                    <Flex direction={"column"}>
                        <Text fontSize="sm" fontWeight="medium" color={valueColor}>
                            {title}
                        </Text>
                        {subtitle && (
                            <Text fontSize="xs" color={subtitleColor}>
                                {subtitle}
                            </Text>
                        )}
                    </Flex>
                    <Box>
                        <Text fontSize="2xl" fontWeight="bold" color={valueColor}>
                            {value}
                        </Text>
                    </Box>
                </Flex>
                : <>
                    <Text fontSize="2xl" fontWeight="bold" color={valueColor}>
                        {value}
                    </Text>
                    <Text fontSize="sm" fontWeight="medium" color="gray.600">
                        {title}
                    </Text>
                    {subtitle && (
                        <Text fontSize="xs" color="gray.500">
                            {subtitle}
                        </Text>
                    )}
                </>}

        </Box>
    );
};

export default InfoCard;
